import cookieLib from 'amkit3-modules/utils/cookie'

export const cookie = (name, value, options) => {
  options = options || {}
  let result = cookieLib.get(name)
  if (typeof result != 'undefined') {
    cookieLib.set(name, result, options)
    return result
  } else {
    if (typeof value != 'undefined') {
      cookieLib.set(name, value, options)
    }
    return value
  }
}

export default {
  cookie,
}
